export const sanitizeConfig = {
    FORBID_ATTR: ['class'],
    ADD_ATTR: ['_field_data'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|priority):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
};
